module.exports = __webpack_public_path__ + "static/media/novena.51b48e34.webp";